document.addEventListener('DOMContentLoaded', function () {
    const possibleLogos = document.getElementsByClassName('header__heading-logo');
    const logo = possibleLogos?.length > 0 ? possibleLogos[0] : undefined;
    if (!logo)
        return;
    logo.src = 'https://apostel.shop/cdn/shop/files/Apostel_Bildmarke_white.png?v=1669191841&width=600';
    logo.srcset = '//apostel.shop/cdn/shop/files/Apostel_Bildmarke_white.png?v=1669191841&width=50 50w, //apostel.shop/cdn/shop/files/Apostel_Bildmarke_white.png?v=1669191841&width=75 75w, //apostel.shop/cdn/shop/files/Apostel_Bildmarke_white.png?v=1669191841&width=100 100w'
});
